export enum GiftMessageSectionThemes {
  DEFAULT = 'default',
  JOIN_FLOW = 'join-flow',
}
